module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="c-block c-collapsePanel ">\r\n  <div class="c-block__title c-collapsePanel__header  ">\r\n    <span class="c-block__titleIcon cw-icon">\r\n      '+
((__t=( UTILS.getSVGIcon('cercle_fleche_bas', 'cw-icon-rot') ))==null?'':__t)+
'\r\n    </span>\r\n    <span class="c-block__titleText cw-titreBloc"></span>\r\n  </div>\r\n  <div class="c-block__content c-collapsePanel " style="display: none;">&nbsp;<br></div>\r\n</div>\r\n';
}
return __p;
};
